export default __webpack_public_path__ + "static/vodafone-logo-932bbeb174d7ef024962dd54bbe9fe1d.png";